/**
 * 物料管理
 * @type {import('vue-router').RouteConfig[]}
 */
const routes = [
  {
    path: '/materialManage/materialIndex',
    name: 'materialIndex',
    meta: { title: '物料管理' },
    component: () => import('@/views/corp/materialManage/materialIndex.vue')
  },
  {
    path: '/materialManage/sapMaterialIndex',
    name: 'sapMaterialIndex',
    meta: { title: 'SAP物料' },
    component: () => import('@/views/corp/materialManage/sapMaterialIndex.vue')
  },
  {
    path: '/materialManage/material-request/index',
    meta: { title: '物料申请' },
    component: () => import('@/views/corp/materialManage/material-request/index.vue')
  },
  {
    path: '/materialManage/material-request/form',
    meta: { title: '物料申请表单' },
    component: () => import('@/views/corp/materialManage/material-request/form.vue')
  },
  {
    path: '/materialManage/material-request/detail',
    meta: { title: '物料申请详情' },
    component: () => import('@/views/corp/materialManage/material-request/detail.vue')
  },
  {
    path: '/materialManage/material-confirm/index',
    meta: { title: '物料申请确认' },
    component: () => import('@/views/corp/materialManage/material-confirm/index.vue')
  },
  {
    path: '/materialManage/material-confirm/form',
    meta: { title: '物料申请确认表单' },
    component: () => import('@/views/corp/materialManage/material-confirm/form.vue')
  },
  {
    path: '/materialManage/material-confirm/detail',
    meta: { title: '物料申请确认详情' },
    component: () => import('@/views/corp/materialManage/material-confirm/detail.vue')
  },
  {
    path: '/materialManage/material-confirm/edit',
    meta: { title: '物料申请确认编辑' },
    component: () => import('@/views/corp/materialManage/material-confirm/edit.vue')
  },
  {
    path: '/materialManage/purchase-request/index',
    meta: { title: '采购申请' },
    component: () => import('@/views/corp/materialManage/purchase-request/index.vue')
  },
  {
    path: '/materialManage/purchase-request/detail',
    meta: { title: '采购申请详情' },
    component: () => import('@/views/corp/materialManage/purchase-request/detail.vue')
  },
  {
    path: '/materialManage/purchase-receive/index',
    meta: { title: '采购收货' },
    component: () => import('@/views/corp/materialManage/purchase-receive/index.vue')
  },

  {
    path: '/materialManage/purchase-receive/detail',
    meta: { title: '采购收货详情' },
    component: () => import('@/views/corp/materialManage/purchase-receive/detail.vue')
  },
  {
    path: '/materialManage/purchase-receive/receive',
    meta: { title: '采购收货确认' },
    component: () => import('@/views/corp/materialManage/purchase-receive/receive.vue')
  },
  {
    path: '/materialManage/purchase-receive/handle-abnormal',
    meta: { title: '采购收货异常处理' },
    component: () => import('@/views/corp/materialManage/purchase-receive/handle-abnormal.vue')
  },
]

export default routes



// WEBPACK FOOTER //
// ./src/router/material-manage.js